import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

import Main from 'layouts/Main';
import Container from 'components/Container';

import { Hero, Jobs, Newsletter, About, CompanyValues } from './components';
import { Typography } from '@mui/material';
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()

const CareerListing = () => {
  const theme = useTheme();
  return (
    <Main>
      {/* <Box> */}

       <Typography
          variant="h4"
          color={'text.secondary'}
          align={'center'}
          gutterBottom
        >
          Blogs - Students
        </Typography>
        <Hero />
        <Typography
          variant="h4"
          color={'text.secondary'}
          align={'center'}
          gutterBottom
        >
          Blogs - Teachers
        </Typography>
          <CompanyValues />
       
        {/* <Container>
          <Divider />
        </Container>
        <Container>
          <About />
        </Container>
        <Box
          component={'svg'}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1920 100.1"
          sx={{
            marginBottom: -1,
            width: 1,
          }}
        >
          <path
            fill={theme.palette.alternate.main}
            d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
          ></path>
        </Box>
      </Box>
      <Box bgcolor={'alternate.main'}>
        <Container maxWidth={1000}>
          <Jobs />
        </Container>
        <Container paddingTop={'0 !important'}>
          <Newsletter />
        </Container>
        <Box
          component={'svg'}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1920 100.1"
          sx={{
            marginBottom: -1,
            width: 1,
          }}
        >
          <path
            fill={theme.palette.background.paper}
            d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
          ></path>
        </Box>
      </Box> */}
    </Main>
  );
};

export default CareerListing;
